import React from "react"

import {
	Grid,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material"

import { Trans } from "@lingui/macro"

import Icon from "@mdi/react"
import {
	mdiContentDuplicate,
	mdiPencilOutline,
	mdiTrashCanOutline,
} from "@mdi/js"

import { TemplateStep } from "models"

export interface TemplateActionsProps
{
	data: TemplateStep
	deleteAction: () => void
	editAction: () => void
	cloneAction: () => void
}
export interface TemplateActionsState
{
}
export class TemplateActions extends React.Component<TemplateActionsProps, TemplateActionsState>
{
	render()
	{
		return(
			<div style={{ overflowX: 'hidden' }}>
				<Grid container alignItems="center" sx={{ pt: 1, pb: 1 }} justifyContent={"flex-end"}>
					<Grid item xs={8}>
						<Stack direction="column">
							<Typography color="#555555" sx={{ fontSize: "16px", fontWeight: '600' }}>
								{this.props.data.name}
							</Typography>
							<Typography color="gray" sx={{ fontSize: "12px" }}>
								<Trans id={"workflow.template.template-actions.deadline-after-days"}>
									Scadenza dopo: {this.props.data.deadlineDays} giorni
								</Trans>
							</Typography>
						</Stack>
					</Grid>
					<Grid item xs={4} textAlign="right">
						<Tooltip title="Modifica" placement="top" arrow>
							<IconButton
								sx={{
									color: 'grey',
									backgroundColor: "transparent",
									":hover": {
										color: "secondary.main"
									}
								}}
								aria-label="Edit"
								onClick={this.props.editAction}
								disableFocusRipple
								disableRipple>
								<Icon path={mdiPencilOutline} size={1} />
							</IconButton>
						</Tooltip>
						<Tooltip title="Duplica" placement="top" arrow>
							<IconButton
								sx={{
									color: 'grey',
									backgroundColor: "transparent",
									":hover": {
										color: "secondary.main"
									}
								}}
								aria-label="Duplicate"
								onClick={this.props.cloneAction}
								disableFocusRipple
								disableRipple>
								<Icon path={mdiContentDuplicate} size={1} />
							</IconButton>
						</Tooltip>
						<Tooltip title="Elimina" placement="top" arrow>
							<IconButton
								sx={{
									color: 'grey',
									backgroundColor: "transparent",
									":hover": {
										color: "secondary.main"
									}
								}}
								aria-label="Delete"
								onClick={this.props.deleteAction}
								disableFocusRipple
								disableRipple>
								<Icon path={mdiTrashCanOutline} size={1} />
							</IconButton>
						</Tooltip>
					</Grid>
				</Grid>
			</div>
		)
	}
}
